import { z } from "@/zod";

export const ulid = z.string().min(26);
